export default {
  props: {
    menuInfo: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      taskList: []
    };
  },

  methods: {
    async getTaskList() {
      const res = await this.$http.getSupervisorTask();
      this.taskList = res.content;
    },

    handleLookDetail(item) {
      window.open(`//sdauxkdd.zhihuishu.com/admin/supervisionTask-edit/${item.task_id}`);
    }

  },

  mounted() {// this.getTaskList()
  }

};